@use "variables" as *;

.list {
  display: flex;
  flex-direction: column;
  margin-bottom: $spacing-xxl !important;
  align-items: center;
  padding: $spacing-m !important;
}

.sectionCard {
  margin: $spacing-s;
  border-radius: 16px !important;
  box-sizing: border-box;
  width: 100%;
}

.listItem {
  padding-left: $spacing-l !important;
  padding-right: $spacing-m !important;
}

.usernameTitle {
  font-size: $fontSize-m;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.itemTitle {
  font-size: $fontSize-m;
  font-weight: bold;
  white-space: pre-wrap;
}

.avatar {
  width: 23px !important;
  height: 23px !important;
  border-width: 1px;
}

.betaTag {
  border-radius: 4px;
  font-size: $fontSize-xxxs;
  font-weight: bold;
  display: flex;
  align-items: center;
  padding-left: $spacing-xs;
  padding-right: $spacing-xs;
  height: 16px;
  align-self: center;
}
